//  Loosley based on this article: https://alxmrtnz.com/thoughts/2019/03/12/environment-variables-and-workflow-in-expo.html

import Constants from 'expo-constants';
const clientId = Constants.manifest.extra.clientId;
const monitorApiKey = Constants.manifest.extra.monitorApiKey;
const gaTrackingId = Constants.manifest.extra.gaTrackingId;

const ENV = {
  local: {
    clientId,
    monitorApiKey,
    redirectUri: 'http://localhost:19006/Fan/Listen/Discover',
    gaTrackingId,
  },
  dev: {
    clientId,
    monitorApiKey,
    redirectUri: 'https://dev.tonebirds.com/Fan/Listen/Discover',
    gaTrackingId,
  },
  beta: {
    clientId,
    monitorApiKey,
    redirectUri: 'https://beta.tonebirds.com/Fan/Listen/Discover',
    gaTrackingId,
  },
  prod: {
    clientId,
    monitorApiKey,
    redirectUri: '[your.production.api.here]',
    gaTrackingId,
  },
};

const getEnvVars = (env = Constants.manifest.extra.environment) => {
  // What is __DEV__ ?
  // This variable is set to true when react-native is running in Dev mode.
  // __DEV__ is true when run locally, but false when published.

  if (__DEV__) {
    return ENV.local;
  } else if (env === 'dev') {
    return ENV.dev;
  } else if (env === 'beta') {
    return ENV.beta;
  }
};

export default getEnvVars;
